module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteVacancyList":"If you delete this job selection, your QR code will no longer work.","delete":"Delete","cancel":"Cancel"}}')
  delete Component.options._Ctor
}
